export const companyDashboardEn = {
  current: 'Current',
  archive: 'Archive',
  forAdministration: 'For administration',
  openTasks: 'Open tasks',
  projectName: 'Project name...',
  departmentName: 'Department name...',
  settings: 'Company settings',
  unassignedEmployees: 'Users without a project',
  keyEmployees: 'Key employees',
  employee: 'Name',
  userIsBlocked: 'Blocked',
  quickInviteLink: 'Invite link',
  addUser: 'Add a user',
  addVirtualUser: 'Add a virtual user',
  banners: {
    trello: {
      importFrom: 'Import from',
      moveProjects: 'Transfer your projects from Trello',
      startImport: 'Start import'
    },
    extensions: {
      title: 'New automations and integrations',
      subtitle: 'Try 15+ free extensions',
      action: 'Go to extensions'
    }
  }
}

export const companyDashboardRu: typeof companyDashboardEn = {
  current: 'Текущие',
  archive: 'Архив',
  forAdministration: 'Для администрирования',
  openTasks: 'Открытых задач',
  projectName: 'Название проекта...',
  departmentName: 'Название отдела...',
  settings: 'Настройки компании',
  unassignedEmployees: 'Нераспределенные по проектам сотрудники',
  keyEmployees: 'Основные сотрудники',
  employee: 'Имя',
  userIsBlocked: 'Заблокирован',
  quickInviteLink: 'Ссылка для быстрой регистрации',
  addUser: 'Добавить сотрудника',
  addVirtualUser: 'Добавить виртуального сотрудника',
  banners: {
    trello: {
      importFrom: 'Импорт из',
      moveProjects: 'Перенесите свои проекты из сервиса Trello',
      startImport: 'Начать импорт'
    },
    extensions: {
      title: 'Новые автоматизации и интеграции',
      subtitle: 'Попробуйте 15+ бесплатных расширений',
      action: 'Перейти к расширениям'
    }
  }
}
